<template>
  <div>
    <template v-for="match in matches">
      <TheUpcomingSummerMatch
        :key="`upcoming-match-${match.id}`"
        :match="match"
        :my-score-predictions="getMyPredictedScoreForMatch(match.id)"
        @onMatchScoreChange="(param) => handleMatchScoreChange(param, getMyPredictedScoreForMatch(match.id))"
      />
    </template>
    <InfoBlock
      id="infoBlock"
      :title="$t('increase-your-chance-to-win')"
      :description="$t('pick-a-player-who-will-score-during-the-game-and-increase-your-chance-to-hit-the-jackpot')"
      image="bulb.png"
    />
    <AddPlayer
      :round-id="round.id"
      :round="round"
      :maximum-picked-players-count="1"
      :is-search-enabled="false"
      league-type="summer"
    />
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { mapGetters } from 'vuex'
import InfoBlock from '@/pages/RoundDetail/Components/Atoms/InfoBlock'
import TheUpcomingSummerMatch from '@/pages/RoundDetail/Components/Molecules/TheUpcomingSummerMatch'
import AddPlayer from '@/pages/RoundDetail/Routes/MyTeam/AddPlayer/AddPlayer'
export default {
  name: 'UpcomingSummerRound',
  components: {
    AddPlayer,
    TheUpcomingSummerMatch,
    InfoBlock,
  },
  props: {
    round: {
      type: Object,
      default: () => {},
    },
    matches: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      getMyPredictedScoreForMatch: 'rounds/summer/matchScore/getPredictedScoreForMatch',
    }),
    selectedAthletesCount() {
      return this.$store.getters['rounds/athletesInRound/getCountOfSelectedAthletesForRound'](this.round.id)
    },
  },
  methods: {
    handleMatchScoreChange(params, myPredictions) {
      if (!myPredictions || (params.team1score !== myPredictions.team1score || params.team2score !== myPredictions.team2score)) {
        this.$emit('onMatchScoreChange', params)
        if (this.selectedAthletesCount === 0) {
          VueScrollTo.scrollTo('#infoBlock', 500, {
            container: 'body',
          })
        }
      }
    },
  },
}
</script>

<style scoped>

</style>
